module.exports = __webpack_public_path__ + "static/media/taskinator.a40313a2.jpg";